import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { storageGet, storageSet } from "../lib/log";

const DISMISS_KEY = "ghbb_promo_dismissed";

export default function PromoBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!storageGet(DISMISS_KEY)) setVisible(true);
  }, []);

  const dismiss = () => {
    setVisible(false);
    storageSet(DISMISS_KEY, "1");
  };

  if (!visible) return null;

  return (
    <div
      className="bg-[#2C241B] text-[#F9F6F0] text-[12px] tracking-[0.14em]"
      data-testid="promo-banner"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <span
            className="shrink-0 font-semibold bg-[#F9F6F0] text-[#2C241B] px-2 py-0.5 text-[10px] tracking-[0.18em]"
            aria-hidden="true"
          >
            -15%
          </span>
          <span className="truncate">
            <span className="hidden sm:inline">{t("promo.text")}</span>
            <span className="sm:hidden">{t("promo.short")}</span>
          </span>
          <Link
            to="/reserver"
            data-testid="promo-banner-cta"
            className="hidden md:inline-flex items-center gap-1.5 uppercase font-medium underline-offset-4 hover:underline shrink-0"
          >
            {t("promo.cta")}
            <ArrowRight size={12} />
          </Link>
        </div>
        <button
          onClick={dismiss}
          aria-label="Close"
          data-testid="promo-banner-close"
          className="shrink-0 opacity-80 hover:opacity-100 p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
